import React, { FC, Fragment } from 'react';
import { Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useGlobalClient, useContent } from 'hooks';

import { getPhoto, getVideo, hasPhoto, hasVideo } from '../helpers';
import { LoginPublic, MetaPublic, UserPublic } from '../partials';
import { Photo, Video } from '../widgets';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
    marginBottom: 12,
  },
}));

const ManualPublic: FC = () => {
  const classes = useStyles();
  const content = useContent();
  const client = useGlobalClient();

  function getContent() {
    if (hasVideo(content)) {
      const video = getVideo(content);
      return <Video video={video} autoPlay />;
    }

    if (hasPhoto(content)) {
      const photo = getPhoto(content);
      return <Photo photo={photo} />;
    }

    return null;
  }

  return (
    <Fragment>
      <LoginPublic />
      <Card className={classes.root}>
        {client.public_post_details && <UserPublic />}
        <div className={classes.content}>{getContent()}</div>
        <MetaPublic />
      </Card>
    </Fragment>
  );
};

export default ManualPublic;
